export default __webpack_public_path__ + "static/media/RAMbrandt.4313dc44.png";